import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pend-section" }
const _hoisted_2 = { class: "pend-header" }
const _hoisted_3 = {
  key: 0,
  class: "pend-empty"
}
const _hoisted_4 = {
  key: 1,
  class: "pend-empty"
}
const _hoisted_5 = {
  key: 2,
  class: "pend-list"
}
const _hoisted_6 = { class: "pend-card-top" }
const _hoisted_7 = { class: "pend-card-info" }
const _hoisted_8 = { class: "pend-short" }
const _hoisted_9 = { class: "pend-meta" }
const _hoisted_10 = { class: "pend-card-badges" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "pend-card-actions" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pend-modal" }
const _hoisted_16 = { class: "pend-modal-header" }
const _hoisted_17 = { class: "pend-modal-title" }
const _hoisted_18 = { class: "pend-modal-body" }
const _hoisted_19 = { class: "pend-detail-row" }
const _hoisted_20 = { class: "pend-detail-val" }
const _hoisted_21 = { class: "pend-detail-row" }
const _hoisted_22 = { class: "pend-detail-val" }
const _hoisted_23 = {
  key: 0,
  class: "pend-detail-row"
}
const _hoisted_24 = { class: "pend-detail-val pend-task-link" }
const _hoisted_25 = {
  key: 1,
  class: "pend-detail-full"
}
const _hoisted_26 = { class: "pend-full-text" }
const _hoisted_27 = {
  key: 2,
  class: "pend-detail-photo"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "pend-modal pend-modal--form" }
const _hoisted_30 = { class: "pend-modal-header" }
const _hoisted_31 = { class: "pend-modal-title" }
const _hoisted_32 = { class: "pend-modal-body" }
const _hoisted_33 = { class: "pend-form-field" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "pend-form-field" }
const _hoisted_36 = { class: "pend-form-field" }
const _hoisted_37 = { class: "pend-form-field" }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "pend-form-field" }
const _hoisted_40 = {
  key: 0,
  class: "pend-image-preview"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 0,
  class: "pend-form-error"
}
const _hoisted_43 = { class: "pend-modal-footer" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "pend-modal-footer-right" }
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "pend-title" }, "Pendências", -1)),
      (_ctx.accessMode === 'edit')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary pend-new-btn",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCreateForm && _ctx.openCreateForm(...args)))
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("svg", {
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
              }),
              _createElementVNode("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
              })
            ], -1),
            _createTextVNode(" Nova pendência ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando…"))
      : (_ctx.items.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[23] || (_cache[23] = _createElementVNode("svg", {
              width: "40",
              height: "40",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.2",
              "stroke-linecap": "round"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              }),
              _createElementVNode("path", { d: "M12 8v4l3 3" })
            ], -1)),
            _cache[24] || (_cache[24] = _createElementVNode("p", null, "Nenhuma pendência registrada.", -1)),
            (_ctx.accessMode === 'edit')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openCreateForm && _ctx.openCreateForm(...args)))
                }, "Registrar pendência"))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "pend-card"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.shortDescription), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.responsavel) + " · " + _toDisplayString(_ctx.formatDate(item.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (item.taskId)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "pend-badge pend-badge--task",
                          title: item.taskTitle
                        }, [
                          _cache[25] || (_cache[25] = _createElementVNode("svg", {
                            width: "11",
                            height: "11",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2"
                          }, [
                            _createElementVNode("polyline", { points: "9 11 12 14 22 4" }),
                            _createElementVNode("path", { d: "M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" })
                          ], -1)),
                          _createTextVNode(" " + _toDisplayString(item.taskTitle || 'Atividade'), 1)
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "pend-action-btn",
                      type: "button",
                      title: "Ver detalhes",
                      onClick: ($event: any) => (_ctx.openView(item))
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("circle", {
                          cx: "11",
                          cy: "11",
                          r: "8"
                        }),
                        _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                      ], -1),
                      _createTextVNode(" Ver ", -1)
                    ]))], 8, _hoisted_13),
                    (_ctx.accessMode === 'edit')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "pend-action-btn",
                          type: "button",
                          title: "Editar",
                          onClick: ($event: any) => (_ctx.openEdit(item))
                        }, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" }),
                            _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" })
                          ], -1),
                          _createTextVNode(" Editar ", -1)
                        ]))], 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.viewItem)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "pend-overlay",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.viewItem = null), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.viewItem.shortDescription), 1),
                _createElementVNode("button", {
                  class: "pend-modal-close",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewItem = null))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "pend-detail-label" }, "Responsável", -1)),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.viewItem.responsavel || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "pend-detail-label" }, "Registrado por", -1)),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.viewItem.createdBy) + " · " + _toDisplayString(_ctx.formatDate(_ctx.viewItem.createdAt)), 1)
                ]),
                (_ctx.viewItem.taskId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[31] || (_cache[31] = _createElementVNode("span", { class: "pend-detail-label" }, "Atividade vinculada", -1)),
                      _createElementVNode("span", _hoisted_24, [
                        _cache[30] || (_cache[30] = _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.2"
                        }, [
                          _createElementVNode("polyline", { points: "9 11 12 14 22 4" }),
                          _createElementVNode("path", { d: "M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.viewItem.taskTitle || _ctx.viewItem.taskId), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.viewItem.fullDescription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "pend-detail-label" }, "Descrição completa", -1)),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.viewItem.fullDescription), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.viewItem.photo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "pend-detail-label" }, "Foto", -1)),
                      _createElementVNode("img", {
                        src: _ctx.viewItem.photo,
                        class: "pend-photo-img",
                        alt: "Foto da pendência"
                      }, null, 8, _hoisted_28)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "pend-overlay",
            onClick: _cache[20] || (_cache[20] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.editingId ? 'Editar pendência' : 'Nova pendência'), 1),
                _createElementVNode("button", {
                  class: "pend-modal-close",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { class: "pend-form-label" }, "Responsável", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.responsavel) = $event)),
                    class: "pend-form-input"
                  }, [
                    _cache[34] || (_cache[34] = _createElementVNode("option", { value: "" }, "Selecione o responsável", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userOptions, (u) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: u.uid,
                        value: u.name
                      }, _toDisplayString(u.name), 9, _hoisted_34))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.responsavel]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", { class: "pend-form-label" }, [
                    _createTextVNode("Descrição curta "),
                    _createElementVNode("span", { class: "pend-required" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.shortDescription) = $event)),
                    class: "pend-form-input",
                    type: "text",
                    placeholder: "Resumo da pendência"
                  }, null, 512), [
                    [_vModelText, _ctx.form.shortDescription]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { class: "pend-form-label" }, "Descrição completa", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.fullDescription) = $event)),
                    class: "pend-form-input pend-form-textarea",
                    rows: "4",
                    placeholder: "Detalhes, contexto, ações necessárias…"
                  }, null, 512), [
                    [_vModelText, _ctx.form.fullDescription]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", { class: "pend-form-label" }, "Atividade (opcional)", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.taskId) = $event)),
                    class: "pend-form-input",
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onTaskChange && _ctx.onTaskChange(...args)))
                  }, [
                    _cache[38] || (_cache[38] = _createElementVNode("option", { value: "" }, "Nenhuma atividade", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasks, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.id,
                        value: t.id
                      }, _toDisplayString(t.title), 9, _hoisted_38))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.form.taskId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", { class: "pend-form-label" }, "Foto (opcional)", -1)),
                  _createElementVNode("div", {
                    class: _normalizeClass(["pend-image-grid", { 'is-drag-over': _ctx.photoDragOver }]),
                    onDragenter: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.photoDragOver = true), ["prevent"])),
                    onDragover: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.photoDragOver = true), ["prevent"])),
                    onDragleave: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.photoDragOver = false), ["prevent"])),
                    onDrop: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onPhotoDrop && _ctx.onPhotoDrop(...args)), ["prevent"]))
                  }, [
                    (_ctx.form.photo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("img", {
                            src: _ctx.form.photo,
                            alt: "preview"
                          }, null, 8, _hoisted_41),
                          _createElementVNode("button", {
                            class: "pend-image-remove",
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.photo = '')),
                            "aria-label": "Remover foto"
                          }, [...(_cache[40] || (_cache[40] = [
                            _createElementVNode("span", { class: "pend-trash-icon" }, null, -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.form.photo)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "pend-image-add",
                          type: "button",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.triggerPhotoInput && _ctx.triggerPhotoInput(...args)))
                        }, [...(_cache[41] || (_cache[41] = [
                          _createElementVNode("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 18 18",
                            fill: "none"
                          }, [
                            _createElementVNode("path", {
                              d: "M9 4v10M4 9h10",
                              stroke: "currentColor",
                              "stroke-width": "1.6",
                              "stroke-linecap": "round"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 34),
                  _createElementVNode("input", {
                    ref: "photoInputRef",
                    type: "file",
                    accept: "image/*",
                    class: "pend-hidden-input",
                    onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                  }, null, 544)
                ]),
                (_ctx.formError)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.formError), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                (_ctx.editingId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-danger",
                      type: "button",
                      disabled: _ctx.saving,
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.deletePendencia && _ctx.deletePendencia(...args)))
                    }, "Apagar", 8, _hoisted_44))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("button", {
                    class: "btn btn-ghost",
                    type: "button",
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "button",
                    disabled: _ctx.saving,
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
                  }, _toDisplayString(_ctx.saving ? 'Salvando…' : (_ctx.editingId ? 'Salvar' : 'Registrar')), 9, _hoisted_46)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}